module.exports = __webpack_public_path__ + "img/open_24_grey.b22d11fe.svg";